module.exports = __webpack_public_path__ + "static/media/video.827069fc.svg";